import React, { ChangeEventHandler, FormEventHandler } from 'react';

import { Box, Button, Stack, TextField } from '@mui/material';

const DEFAULT_SEARCH_LABEL = 'Name / Email / Customer Support Code / User ID';

type Props = {
  searchString: string;
  handleChange: ChangeEventHandler<HTMLInputElement>;
  handleSubmit: FormEventHandler<HTMLFormElement>;
  label?: string;
};

export default function UserSearchForm({
  searchString,
  handleChange,
  handleSubmit,
  label = DEFAULT_SEARCH_LABEL,
}: Props) {
  return (
    <form onSubmit={handleSubmit}>
      <Stack direction="row" spacing={2} alignItems="center">
        <Box flex={1}>
          <TextField
            id="UserSearch"
            data-testid="UserSearch"
            type="text"
            name="searchString"
            label={label}
            placeholder={`Enter ${label}`}
            value={searchString}
            onChange={handleChange}
            autoFocus
            fullWidth
          />
        </Box>

        <Button type="submit" variant="contained" className="T-search-user">
          Search
        </Button>
      </Stack>
    </form>
  );
}
